var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: { title: "Crear festivo", visible: _vm.showing, width: "35%" },
      on: {
        "update:visible": function ($event) {
          _vm.showing = $event
        },
      },
    },
    [
      _vm.showing
        ? _c("Holidays-Form", {
            attrs: { loading: _vm.loading },
            on: { submit: _vm.onSubmitCreate },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }